import React, { useState } from "react";
import "./RoundedSelectionToggle.css";

export type RoundedSelectionToggleOption = {
    value: string;
    label: string;
};

type Props = {
    options: RoundedSelectionToggleOption[];
    initialValue?: string;
    onChange?: (value: string) => void;
};

const RoundedSelectionToggle = function RoundedSelectionToggle(props: Props) {
    const { options, initialValue, onChange } = props;
    const [selected, setSelected] = useState(initialValue);

    return (
        <div className="rounded-selection-toggle">
            {options.map((option) => {
                const isSelected = option.value === selected;
                return (
                    <div
                        key={option.value}
                        className={
                            isSelected
                                ? "rounded-selection-toggle__option rounded-selection-toggle__option--selected"
                                : "rounded-selection-toggle__option"
                        }
                        onClick={() => {
                            setSelected(option.value);
                            if (onChange) {
                                onChange(option.value);
                            }
                        }}
                    >
                        {option.label}
                    </div>
                );
            })}
        </div>
    );
};

export default RoundedSelectionToggle;
